import type { Numberish, TDescription, TSelectorItem } from "@/models/common.model"
import { languageParser } from "./language.mapper"

export class SelectorMapper {
  static toDto<T extends { code: string, description?: TDescription }>(rawData: T[]): TSelectorItem[] {
    return rawData.map(item => ({
      value: item.code as Numberish,
      label: languageParser(item.description).long,
      original: item,
    }))
  }
}
